import { postStyles } from "./forum-post.styles";
import * as stylex from "@stylexjs/stylex";
import { Alert } from "@softmax/design-system";
import { styles } from "../forum.styles";
import { VoteButton } from "../forum-vote-button";
import { Byline } from "../forum-byline";
import { ForumPostBody } from "./forum-post-body";
import type {
  ForumPostRecord,
  ForumVote,
  ForumImageShare,
  ForumLinkRenderer,
  ForumMarkdownRenderer,
} from "../forum.types";
export function ForumPostArticle({
  post,
  layout,
  postVote,
  onPostVote,
  shareImage,
  name,
  renderLink,
  renderMarkdown,
  commentCount,
}: Readonly<{
  post: ForumPostRecord;
  layout: "page" | "embedded";
  postVote: ForumVote | undefined;
  onPostVote(direction: 1 | -1): void;
  shareImage: ForumImageShare | undefined;
  name: string;
  renderLink: ForumLinkRenderer;
  renderMarkdown: ForumMarkdownRenderer;
  commentCount: number | null | undefined;
}>) {
  const Title = layout === "page" ? "h1" : "h2";
  return (
    <article {...stylex.props(postStyles.article)}>
      <div {...stylex.props(postStyles.voteStack)}>
        <VoteButton
          direction={1}
          label={post.title}
          vote={postVote}
          onVote={onPostVote}
        />
        <span
          aria-label={`${post.score} points`}
          {...stylex.props(styles.score)}
        >
          {post.score}
        </span>
        <VoteButton
          direction={-1}
          label={post.title}
          vote={postVote}
          onVote={onPostVote}
        />
      </div>
      <div {...stylex.props(styles.content)}>
        {postVote?.error && (
          <Alert tone="danger" announcement="assertive">
            {postVote.error}
          </Alert>
        )}
        <div
          ref={shareImage?.cardRef}
          {...stylex.props(postStyles.shareContent)}
        >
          <p {...stylex.props(styles.eyebrow)}>{name}</p>
          <Title
            {...stylex.props(
              postStyles.articleTitle,
              layout === "embedded" && styles.embeddedTitle,
            )}
          >
            {post.title}
          </Title>
          <Byline
            {...post}
            renderLink={renderLink}
            commentCount={commentCount}
          />
          <ForumPostBody post={post} renderMarkdown={renderMarkdown} />
        </div>
      </div>
    </article>
  );
}
